import { CommonEnums } from '../../common.enums'
import { Fldr } from '../datapoint/fldr';
import { Layer } from '../layer';
import { Fla_Fldr } from '../datapoint/fla_fldr';
import { Param } from '../domain/param';
import { Usr } from '../usr';
import { Sch_Queue_Fldr } from '../sch_queue_fldr';
import { ParamsUtil } from '../utils/params.util';
import { LayersUtil } from '../utils/layers.util';
import { Fla_FldrsUtil } from '../utils/fla_fldrs.util';
import { Sch_Queue_FldrsUtil } from '../utils/sch_queue_fldrs.util';
import { UsrsUtil } from '../utils/usrs.util';


export class RepFolder {
  fldr: Fldr;
  layers: Array<Layer>;
  fla_Fldrs: Array<Fla_Fldr>;
  params: Array<Param>;
  lockBy: string
  mode_Ind: string;
  error_Cd: string;
  error_Msg: string;
  sch_Queue_Fldrs: Array<Sch_Queue_Fldr>;
  change_Ind: string;
  usrs: Array<Usr>;

  constructor() {
    this.setDefaults();
  }

  setDefaults(): void {
    this.fldr = new Fldr();
    this.layers = new Array<Layer>();
    this.fla_Fldrs = new Array<Fla_Fldr>();
    this.params = new Array<Param>();
    this.lockBy = CommonEnums.defaults.STRING_EMPTY;
    this.mode_Ind = CommonEnums.defaults.STRING_EMPTY;
    this.error_Cd = CommonEnums.defaults.STRING_EMPTY;
    this.error_Msg = CommonEnums.defaults.STRING_EMPTY;
    this.sch_Queue_Fldrs = new Array<Sch_Queue_Fldr>();
    this.change_Ind = CommonEnums.change_Ind.NO_CHANGE;
    this.usrs = new Array<Usr>();
  }

  static parse(repFolderTmp: RepFolder): RepFolder {
    let repFolder: RepFolder = new RepFolder();
    repFolder.copyFrom(repFolderTmp);
    return repFolder;
  }

  copy(): RepFolder {
    let repFolderTmp: RepFolder = new RepFolder();
    repFolderTmp.fldr = this.fldr.copy();
    repFolderTmp.layers = LayersUtil.getInstance().copy(this.layers);
    repFolderTmp.fla_Fldrs = Fla_FldrsUtil.getInstance().copy(this.fla_Fldrs);
    repFolderTmp.params = ParamsUtil.getInstance().copy(this.params);
    repFolderTmp.lockBy = this.lockBy;
    repFolderTmp.mode_Ind = this.mode_Ind;
    repFolderTmp.error_Cd = this.error_Cd;
    repFolderTmp.error_Msg = this.error_Msg;
    repFolderTmp.sch_Queue_Fldrs = Sch_Queue_FldrsUtil.getInstance().copy(this.sch_Queue_Fldrs);
    repFolderTmp.change_Ind = this.change_Ind;
    repFolderTmp.usrs = UsrsUtil.getInstance().copy(this.usrs);

    return repFolderTmp;
  }

  copyFrom(repFolderTmp: RepFolder): void {
    this.fldr.copyFrom(repFolderTmp.fldr);
    LayersUtil.getInstance().copyFrom(this.layers, repFolderTmp.layers);
    Fla_FldrsUtil.getInstance().copyFrom(this.fla_Fldrs, repFolderTmp.fla_Fldrs);
    ParamsUtil.getInstance().copyFrom(this.params, repFolderTmp.params);
    this.lockBy = repFolderTmp.lockBy;
    this.mode_Ind = repFolderTmp.mode_Ind;
    this.error_Cd = repFolderTmp.error_Cd;
    this.error_Msg = repFolderTmp.error_Msg;
    Sch_Queue_FldrsUtil.getInstance().copyFrom(this.sch_Queue_Fldrs, repFolderTmp.sch_Queue_Fldrs);
    this.change_Ind = repFolderTmp.change_Ind;
    UsrsUtil.getInstance().copyFrom(this.usrs, repFolderTmp.usrs);
  }

  compare(repFolderTmp: RepFolder): string {
    let diffString: string = this.fldr.compare(repFolderTmp.fldr);
    if (diffString != '') return diffString;
    diffString = LayersUtil.getInstance().compare(this.layers, repFolderTmp.layers);
    if (diffString != '') return diffString;
    diffString = Fla_FldrsUtil.getInstance().compare(this.fla_Fldrs, repFolderTmp.fla_Fldrs);
    if (diffString != '') return diffString;
    diffString = ParamsUtil.getInstance().compare(this.params, repFolderTmp.params);
    if (diffString != '') return diffString;
    diffString = Sch_Queue_FldrsUtil.getInstance().compare(this.sch_Queue_Fldrs, repFolderTmp.sch_Queue_Fldrs);
    if (diffString != '') return diffString;
    diffString = UsrsUtil.getInstance().compare(this.usrs, repFolderTmp.usrs);
    if (diffString != '') return diffString;
    return '';
  }

  toString(): string {
    return "RepFolder [fldr=" + this.fldr +
      ",layers = " + LayersUtil.getInstance().toString(this.layers) +
      ",fla_Fldrs = " + Fla_FldrsUtil.getInstance().toString(this.fla_Fldrs) +
      ",params = " + ParamsUtil.getInstance().toString(this.params) +
      ",lockBy = " + this.lockBy +
      ",mode_Ind = " + this.mode_Ind +
      ",error_Cd = " + this.error_Cd +
      ",error_Msg  =" + this.error_Msg +
      ",sch_Queue_Fldrs = " + Sch_Queue_FldrsUtil.getInstance().toString(this.sch_Queue_Fldrs) +
      ",change_Ind = " + this.change_Ind +
      ",usrs =" + UsrsUtil.getInstance().toString(this.usrs) + "]";
  }
}